import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowUpRight } from "lucide-react";
import { fetchSite } from "@/lib/api";
import { cn } from "@/lib/utils";

export const useCredit = () => {
  const { data: site } = useQuery({ queryKey: ["site"], queryFn: fetchSite, staleTime: 5 * 60 * 1000 });
  if (!site || site.credit_show === false || !site.credit_name) return null;
  return { name: site.credit_name, url: site.credit_url || null, email: site.credit_email || null, tagline: site.credit_tagline || null, text: site.credit_text || null };
};

/** «Design og utvikling: Kviteberg AS» – one quiet line, linked to the studio. `dark` for the ink footer. */
export const MadeBy = ({ dark = false, className, withAbout = false }) => {
  const credit = useCredit();
  if (!credit) return null;
  const base = dark ? "text-paper/55 hover:text-paper" : "text-muted-foreground hover:text-foreground";
  const inner = <>Design og utvikling: <span className={cn("font-medium", dark ? "text-paper/80" : "text-foreground")}>{credit.name}</span></>;
  return (
    <span className={cn("inline-flex flex-wrap items-center gap-x-4 gap-y-1 text-[13px]", className)} data-testid="made-by">
      {credit.url
        ? <a href={credit.url} target="_blank" rel="noopener" className={cn("group inline-flex items-center gap-1 transition-colors duration-200", base)} data-testid="made-by-link">{inner}<ArrowUpRight className="h-3 w-3 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></a>
        : <span className={base} data-testid="made-by-text">{inner}</span>}
      {withAbout && <Link to="/om-nettsida" className={cn("u-hover transition-colors duration-200", base)} data-testid="made-by-about">Om nettsida</Link>}
    </span>
  );
};
